<div class="row">
  <div class="flex justify-center">
    <button mat-flat-button color="warn" (click)="stopSchedules()" size="2x">Stop Schedules</button>
  </div>
</div>
